// ** Utils
import { isUserLoggedIn } from '@utils'

// **  Initial State
let initialState = { userData: {} }

if (isUserLoggedIn())  {

  const tilo = JSON.parse(localStorage.getItem('analyzerTiloData'))

  const BabelData = JSON.parse(localStorage.getItem("troiatec"))


  const userData = JSON.parse(localStorage.getItem('userData')),
  accessToken = userData.accessToken

  initialState = {
    userData: {...userData},
    accessToken: `${accessToken}`,
    Babel: {...BabelData},
    tiloData: tilo
  }
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        userData: action.data,
        [action.config.storageTokenKeyName]:
          action[action.config.storageTokenKeyName]
        // [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case "LOGOUT":
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, tiloData: {}, ...obj }
    case "HANDLE_TOUR":
      return { ...state, userData: { ...action.value } }
    case "HANDLE_RPASSWORD":
      return { ...state, userData: { ...action.value } }
    case "TILO_DATA":
      return { ...state, tiloData: { ...action.data } }
    case "HANDLE_TOKEN":
      return { ...state, accessToken: action.value }
    case "HANDLE_BABEL":
      return { ...state, Babel: { ...action.value} }
    case "HANDLE_USER_DATA":
      return { ...state, userData: { ...action.value} }
    default:
      return state
  }
}

export default authReducer
